/**
 * 手工换行（UI 面板共用）：CJK 按整字宽、ASCII 按 0.55 字宽估算，超宽断行；
 * 断点优先取行内最近空格（英文不断词），无空格时按字符断。
 * maxLines 截断（超出部分丢弃），默认不限。
 * 音乐室评论、符卡练习介绍、制作名单、难度说明、选人介绍等长文处使用。
 */
export function wrapText(text, maxWidth, size, maxLines = Infinity) {
  const cjk = (ch) => /[⺀-鿿豈-﫿＀-￿　-〿぀-ヿ가-힯ᄀ-ᇟ]/.test(ch);
  const widthOf = (s) => {
    let w = 0;
    for (const ch of s) w += cjk(ch) ? size : size * 0.55;
    return w;
  };
  const lines = [];
  let line = '';
  let w = 0;
  for (const ch of text) {
    const cw = cjk(ch) ? size : size * 0.55;
    if (w + cw > maxWidth && line) {
      const sp = line.lastIndexOf(' ');
      if (sp > 0 && !cjk(ch)) {
        lines.push(line.slice(0, sp));
        line = line.slice(sp + 1) + ch;
        w = widthOf(line);
      } else {
        lines.push(line);
        // 字符断时新行以空格开头则剥掉（否则该行渲染莫名缩进——历史 bug）
        line = ch === ' ' ? '' : ch;
        w = ch === ' ' ? 0 : cw;
      }
      if (lines.length >= maxLines) return lines;
    } else {
      line += ch;
      w += cw;
    }
  }
  if (line && lines.length < maxLines) lines.push(line);
  return lines;
}

/** 估算单行渲染宽度（与 wrapText 同一度量：CJK 全角=size，其余 0.55×size）。 */
export function textWidth(s, size) {
  const cjk = (ch) => /[⺀-鿿豈-﫿＀-￿　-〿぀-ヿ가-힯ᄀ-ᇟ]/.test(ch);
  let w = 0;
  for (const ch of s) w += cjk(ch) ? size : size * 0.55;
  return w;
}

/**
 * 面板长文自适应绘制：从 (size=12, lh=17) 起，超出可用高度时逐级缩小
 * （11/16、10/15）重排，保证不出屏。返回实际行数。
 * 注意：首档容量（size 12 / lh 17）由 tools/ui-fit-check.mjs 做回归断言，
 * 任何新增长文都应能在首档内容下，而不是依赖降级兜底。
 */
export const FIT_TIERS = [[12, 17], [11, 16], [10, 15]];
export function drawFittedText(r, text, x, y, maxWidth, bottomLimit, color = '#dde') {
  let [size, lh] = FIT_TIERS[0];
  let lines = wrapText(text, maxWidth, size);
  for (const [s, h] of FIT_TIERS.slice(1)) {
    if (lines.length * lh <= bottomLimit - y) break;
    size = s; lh = h;
    lines = wrapText(text, maxWidth, size);
  }
  for (let i = 0; i < lines.length; i++) {
    r.text(lines[i], x, y + i * lh, { size, color });
  }
  return lines.length;
}
